import React, { useRef } from "react";
import useOnClickOutside from "_hooks/useOnClickOutside";
import { Modal } from "../../_components/modal/index";

import "./index.css";

const Language = (props) => {
  const { language, handleLanguageChange, setOpenSetting } = props;
  const filterPopupRef = useRef(null);
  useOnClickOutside(filterPopupRef, () => setOpenSetting(false));

  return (
    <Modal
      title="Setting"
      refAction={filterPopupRef}
      btnAction={""}
      secondBtnTxt="Ok"
      closeSetState={setOpenSetting}
    >
      <div className="lang ">
        Langauage:
        <select value={language} onChange={handleLanguageChange}>
          <option value="en">English</option>
          <option value="fil">Filipino</option>
        </select>
      </div>
    </Modal>
  );
};
export { Language };
